import React, { useRef, useContext, forwardRef } from 'react';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import { FirebaseContext } from '../../context/FirebaseContext';
import { NumInWords } from './FeesBilling/components/BillNumberModal/PrintReceipt';
import moment from 'moment';
import ReactToPrint from 'react-to-print';
import Button from '../../NecttosComp/Button/Button';

const VoucherPrintContent = forwardRef(({ data, selectedCollege, tableContent2 }, ref) => {
  return (
    <div ref={ref} className="printable">
      <div className="bg-white p-6 shadow-lg rounded-lg w-full h-[150mm] border border-gray-300 relative overflow-hidden">
        <div className="flex justify-between items-center mb-2">
          <div className="flex items-center">
            {selectedCollege?.logo && (
              <img src={selectedCollege.logo} alt="College Logo" className="max-w-[80px] mr-4" />
            )}
            <div>
              <h3 className="text-xl font-bold">{selectedCollege?.collegeName}</h3>
              <p className="text-sm">{selectedCollege?.address}</p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-sm font-bold">Date: {moment(data?.date).format('DD-MM-YYYY')}</p>
            <p className="text-sm font-bold">Vr. No.: {data?.rtNumber || '_._._._._._'}</p>
          </div>
        </div>

        {selectedCollege?.logo && (
          <div className="absolute inset-0 flex justify-center items-center opacity-10">
            <img src={selectedCollege.logo} alt="Watermark" className="max-w-[300px]" />
          </div>
        )}

        <h3 className="text-xl font-bold text-center underline z-10 relative">
          {data?.type === 'Reciept' ? 'RECIEPT' : 'VOUCHER'}
        </h3>

        <div className="relative z-10">
          <table className="min-w-full m-2">
            <tbody>
              <tr>
                <td className={tableContent2} style={{ width: '20%' }}>
                  <p className="fs-4 p-0 m-0">{data?.type === 'Reciept' ? 'Recieved From:' : 'Paid to:'}</p>
                </td>
                <td className={tableContent2} style={{ width: '80%' }}>
                  <p className="fs-3 p-0 m-0 font-bold">{data?.paidTo?.toUpperCase() || 'Guest Person'}</p>
                </td>
              </tr>
            </tbody>
          </table>

          <table className="min-w-full m-2">
            <tbody>
              <tr>
                <td className={tableContent2} style={{ width: '20%' }}><p className="fs-4 p-0 m-0">Amount:</p></td>
                <td className={tableContent2} style={{ width: '80%' }}>
                  <p className="fs-3 p-0 m-0 font-bold">Rs.{data?.amount}/-</p>
                </td>
              </tr>
            </tbody>
          </table>

          <table className="min-w-full m-2">
            <tbody>
              <tr>
                <td className={tableContent2} style={{ width: '100%' }}>
                  Amount in words : ({NumInWords(data?.amount)})
                </td>
              </tr>
            </tbody>
          </table>

          <table className="min-w-full m-2">
            <tbody>
              <tr>
                <td className={tableContent2} style={{ width: '5%', backgroundColor: '#c2c2c2' }}>
                  {data?.type === 'Reciept' ? 'To' : 'From'}
                </td>
                <td className={tableContent2} style={{ width: '45%' }}>{data?.accountName}</td>
                <td className={tableContent2} style={{ width: '5%', backgroundColor: '#c2c2c2' }}>
                  {data?.type === 'Reciept' ? 'From' : 'To'}
                </td>
                <td className={tableContent2} style={{ width: '45%' }}>{data?.wereName}</td>
              </tr>
            </tbody>
          </table>

          <p className="fs-6 px-3">Narration: {data?.naration?.toUpperCase()}</p>

          {data?.type === 'Reciept' ? (
            <table className="min-w-full">
              <tbody>
                <tr><td className={tableContent2} style={{ width: '40%' }}>Signature of the Cashier</td></tr>
                <tr><td className={tableContent2} style={{ width: '40%' }}></td></tr>
              </tbody>
            </table>
          ) : (
            <table className="min-w-full">
              <tbody>
                <tr>
                  <td className={tableContent2} style={{ width: '20%' }}>Prepared By</td>
                  <td className={tableContent2} style={{ width: '20%' }}>Checked By</td>
                  <td className={tableContent2} style={{ width: '20%' }}>Passed By</td>
                  <td className={tableContent2} style={{ width: '40%' }}>Signature of the Payee</td>
                </tr>
                <tr>
                  <td className={tableContent2}>{data?.handledBy}</td>
                  <td className={tableContent2}></td>
                  <td className={tableContent2}>Principal</td>
                  <td className={tableContent2}></td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
});

const Voucher = ({ data, onClose }) => {
  const printRef = useRef();
  const { collegeId, collegeList } = useContext(FirebaseContext);
  const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);
  const tableContent2 = 'px-3 py-0 bg-none border-1 h-12 whitespace-wrap text-left fs-6 text-black';

  return (
    <Main height="95%" width="80%">
      <div className="z-100 p-4">
        <Header className="flex justify-end space-x-2 mb-4">
          <Button type='close'
            onClick={onClose}  
          >
            Close
          </Button>

          <ReactToPrint
            documentTitle="Voucher"
            trigger={() => (
              <Button type='verify'>
                Print
              </Button>
            )}
            content={() => printRef.current}
          />
        </Header>

        <Body>
          <VoucherPrintContent
            ref={printRef}
            data={data}
            selectedCollege={selectedCollege}
            tableContent2={tableContent2}
          />
        </Body>
      </div>
    </Main>
  );
};

export default Voucher;
